import SystemConfigService from '../../services/SystemConfigService';
import { UserConfigurations } from '../types';

interface ThresholdConfig {
  threshold: number;
  before: number;
  after: number;
}

// Returns the appropriate quick bid value depending on the current bid amount
const getQuickBidIncrements = (
  amount: number,
  configurations: UserConfigurations
) => {
  // Fallback config
  const thresholds: ThresholdConfig = {
    threshold: 1000,
    before: 50,
    after: 100
  };

  // Get user config
  const systemConfigService = SystemConfigService.get(configurations);
  const configThresholds: ThresholdConfig = systemConfigService.getBidThresholds();
  const bidThresholds = configThresholds || thresholds;

  // Returns the 'before' value if the amount hasn't exceeded the threshold
  return amount < bidThresholds.threshold
    ? bidThresholds.before
    : bidThresholds.after;
};

export default getQuickBidIncrements;
